import AtmmConfig from "./AtmmConfig";

export default AtmmConfig;
